function GetVatTypeName(type) {
  
    switch (type) {
        case 'B2C':
            return 'Хувь хүн';
        case 'B2B':
            return 'Байгууллага';
        default:
            return 'Хувь хүн';
    }
}

module.exports = GetVatTypeName;